import { logUnlessPageLeft } from 'shared/utils/pageLeave';

export const includeEnvLevelInTitle = () => {
  const envLevel = import.meta.env.PUBLIC_ENV_LEVEL;

  if (envLevel !== 'production' && envLevel !== 'demo') {
    document.title = `Participant Hub (${envLevel})`;
  }
};

export const includeEnvLevelBadgeInFavicon = async () => {
  const envLevel = import.meta.env.PUBLIC_ENV_LEVEL;

  const badgeConfig = {
    local: {
      letter: 'L',
      color: '#2e7d32',
    },
    dev: {
      letter: 'D',
      color: '#380080',
    },
    qa: {
      letter: 'Q',
      color: '#ff2b95',
    },
    staging: {
      letter: 'S',
      color: '#cf7d00',
    },
    uat: {
      letter: 'U',
      color: '#0277bd',
    },
    demo: undefined,
    production: undefined,
  } as const;

  const badgeConfigForLevel = badgeConfig[envLevel];

  if (badgeConfigForLevel) {
    try {
      const response = await fetch('/favicon.svg');
      const svgText = await response.text();

      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
      const svg = svgDoc.documentElement;

      const bg = svgDoc.createElementNS('http://www.w3.org/2000/svg', 'rect');
      bg.setAttribute('x', '0');
      bg.setAttribute('y', '45');
      bg.setAttribute('width', '60');
      bg.setAttribute('height', '60');
      bg.setAttribute('fill', badgeConfigForLevel.color);
      svg.appendChild(bg);

      const text = svgDoc.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.setAttribute('x', '30');
      text.setAttribute('y', '95');
      text.setAttribute('font-size', '60');
      text.setAttribute('font-weight', 'bold');
      text.setAttribute('fill', 'white');
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('font-family', 'Arial, sans-serif');
      text.textContent = badgeConfigForLevel.letter;
      svg.appendChild(text);

      const serializer = new XMLSerializer();
      const modifiedSvg = serializer.serializeToString(svg);
      const blob = new Blob([modifiedSvg], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);

      const faviconLink = document.querySelector<HTMLLinkElement>(
        'link[rel="icon"][type="image/svg+xml"]'
      );

      if (faviconLink) {
        faviconLink.href = url;
      }
    } catch (error) {
      logUnlessPageLeft(
        'Unable to modify favicon SVG to include env level badge',
        error
      );
    }
  }
};
